import ajaxFor from '@/utils/ajaxSet';

export function userCollect(params){

     return ajaxFor({
          url:'User/User/getUserCollectList',
          method:"post",
          data:params
     })

}

export function goCollect(params){

     return ajaxFor({
          url:'User/User/saveCollect',
          method:"post",
          data:params
     })

}

export function unCollect(params){

     return ajaxFor({
          url:'User/User/deleteCollect',
          method:"post",
          data:params
     })

}

export function subSuggest(params){

     return ajaxFor({
          url:'User/User/saveUserFeedback',
          method:"post",
          data:params
     })

}
